export default "__VITE_ASSET__CL8ir4yh__"